import axios from 'axios';
import baseURL from '../../Config';

export async function readSupplierSource(path) {
    const [resource, query] = path.split('?'), params = new URLSearchParams(query);
    const keys = [...params.keys()];
    const valid = params.get('businessUnit') === 'empaque' && new Set(keys).size === keys.length && (resource === 'sync/summary' && keys.length === 1 || resource === 'entities' && keys.every(key => ['businessUnit', 'entityType', 'limit', 'search'].includes(key)) && /^(items?|accounts?|vendors?|bills?|purchases?)$/.test(params.get('entityType')) && params.get('limit') === '500');
    if (!valid) throw new Error('Consulta fuera del alcance de Proveedores.');
    const stored = JSON.parse(localStorage.getItem('userDetails') || localStorage.getItem('adminUser') || '{}');
    const token = stored?.data?.token || stored?.data?.accessToken;
    try {
        const response = await axios({url: `${baseURL}quickbooks/${path}`, method: 'GET', headers: {Authorization: `Bearer ${token}`}});
        return response.data.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'No se pudieron leer las fuentes sincronizadas de QuickBooks.');
    }
}
